export default __webpack_public_path__ + "static/media/accounting-bot_en.91153144.png";